import CreatableSelect from 'react-select/creatable'
import React from 'react'
import { useReactSelect } from './useReactSelect'
import type { SelectCreatableProps } from './index'

export const SelectCreatable = ({ ...props }: SelectCreatableProps) => {
  const properties = useReactSelect(props)

  return <CreatableSelect {...properties} />
}
